import React from "react";
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';

export default function CheckoutEmpty() {
    const currentLanguage = useSelector(
        ({ language }) => language.currentLanguage
    );
    const navbarCategory = useSelector(
        ({ navigation }) => navigation.navbarCategory
    );
    const wording = useSelector(({ language }) => language.wording);
    const basenameURL = useSelector(({ language }) => language.basenameURL);

    return (
        <>
            <section
                style={{
                    backgroundColor: "#7e7e7e",
                    paddingTop: 20,
                    paddingBottom: 20
                }}
            >
                <div className='container relative clearfix'>
                    <ol className='breadcrumb'>
                        <li>
                            <Link to={`${basenameURL}`}>
                                {currentLanguage === "TH"
                                    ? navbarCategory[0].categoryNameTh
                                    : navbarCategory[0].categoryNameEn}
                            </Link>
                        </li>
                        <li className='active'>
                            {wording.checkoutPage.checkoutEmpty.titleEmpty}
                        </li>
                    </ol>
                </div>
            </section>
            <section className='section-wrap-sm'>
                <div className='container'>
                    <div className='row text-center'>
                        <div className='col-md-10 col-md-offset-1'>
                            <div className='icon-warpper'>
                                <img
                                    src='/assets/img/sf/cart-empty.png'
                                    alt='cart-empty.png'
                                />
                            </div>
                            <h1 className='uppercase'>
                                {wording.checkoutPage.checkoutEmpty.bodyMessage}
                            </h1>
                            <p className='white'>
                                {wording.checkoutPage.checkoutEmpty.urlMessage1}{" "}
                                <Link to={`${basenameURL}`}>
                                    {currentLanguage === "TH"
                                        ? navbarCategory[0].categoryNameTh
                                        : navbarCategory[0].categoryNameEn}
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
